import { FC, ChangeEvent } from 'react';
import { Checkbox, FormControlLabel, FormHelperText, styled, SxProps } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

import { useForm } from '@carcareers/contexts';

export interface CheckBoxInputProps {
  label: string;
  name: string;
  required?: boolean;
  disabled?: boolean;
  sx?: SxProps;
}

const IconContainer = styled('span')(({ theme }) => ({
  borderRadius: 8,
  width: 24,
  height: 24,
  border: '1px solid',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const CheckBoxInput: FC<CheckBoxInputProps> = ({ label, name, required, disabled, sx }) => {
  const { setData, getData, getErrors } = useForm();
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => setData(name, e.target.checked);

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={getData<boolean>(name) ?? false}
            onChange={handleChange}
            required={required}
            color="primary"
            disabled={disabled}
            sx={sx}
            icon={<IconContainer />}
            checkedIcon={
              <IconContainer>
                <CheckRoundedIcon sx={{ color: 'primary.main' }} />
              </IconContainer>
            }
          />
        }
        label={label}
      />
      {getErrors(name) && <FormHelperText error>{getErrors(name)}</FormHelperText>}
    </>
  );
};
